module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0726.b26a2ab5.jpg";